<template>
  <div>
    <div class="row" v-if="notLogged">
      <div class="col-md-6 col-md-offset-3">
        <div class="jumbotron">
          <h1>Zaloguj się/Log in</h1>
          <form>
            <div class="form-group">
              <label for="exampleInputEmail1">Email</label>
              <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Email" v-model="email">
            </div>
            <div class="form-group">
              <label for="exampleInputPassword1">Hasło/Password</label>
              <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password" v-model="password">
            </div>
            <div class="form-group" v-if="wrongCridentials">
              <p class="text-danger">{{wrongCridentials}}</p>
            </div>
            <button class="btn btn-primary" @click.prevent="login()">Zaloguj się/Log in</button>
            <button class="btn btn-primary pull-right" v-for="(login, index) in $store.getters.loginProvidersFiltered" :key="index" @click.prevent="azureLogin(login.redirectUrl)">{{login.name}}</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  props: ['lang'],
  data () {
    return {
      email: '',
      password: '',
      wrongCridentials: false,
      notLogged: false
    }
  },
  methods: {
    azureLogin (url) {
      window.location.href = url
    },
    login () {
      this.$http.post('user/login', { email: this.email, password: this.password })
        .then(response => {
          return response.json()
        })
        .then(data => {
          if (data.error) {
            this.wrongCridentials = data.error
          } else {
            let date = new Date()
            date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000))
            let expires = '; expires=' + date.toUTCString()
            document.cookie = 'userid=' + data.user.id + expires + '; path=/'
            this.$store.commit('SET_USER', data.user)
            this.$store.commit('SET_BACKEND_CONFIG', data.backendConfig)
            this.$store.commit('SET_LANG', data.locale)
            this.$store.commit('SET_PRIVILEGES', data.userprivileges)
            this.$store.commit('SET_NETWORKS', data.networks)
            this.$store.commit('SET_ALL_NETWORKS', data.allNetworks)
            this.$store.commit('SET_DEVICES_FILTER_NETWORK', data.user.networks[0])
            this.$store.commit('SET_IS_USER_AUTHENTICATED', true)
            this.$router.push('/')
          }
        })
        .catch(err => {
          this.$notify(`${err.status}: ${err.bodyText}`, 'error', { permanent: true })
        })
    },
    checkMe () {
      console.info('checkme')
      this.$http.get('user/me')
        .then(response => {
          return response.json()
        })
        .then(data => {
          if (data.user) {
            let date = new Date()
            date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000))
            let expires = '; expires=' + date.toUTCString()
            document.cookie = 'userid=' + data.user.id + expires + '; path=/'
            this.$store.commit('SET_USER', data.user)
            this.$store.commit('SET_BACKEND_CONFIG', data.backendConfig)
            this.$store.commit('SET_LANG', data.locale)
            this.$store.commit('SET_PRIVILEGES', data.userprivileges)
            this.$store.commit('SET_NETWORKS', data.networks)
            this.$store.commit('SET_ALL_NETWORKS', data.allNetworks)
            this.$store.commit('SET_DEVICES_FILTER_NETWORK', data.user.networks[0])
            this.$store.commit('SET_IS_USER_AUTHENTICATED', true)
            this.$router.push('/')
            this.$store.commit('SET_LOGIN_PROVIDER', data.providers)
          }
        })
        .catch((err) => {
          if (err.status !== 200) {
            this.$store.commit('SET_LOGIN_PROVIDER', err.body.providers)
            this.notLogged = true
          }
        })
    }
  },
  created () {
    this.checkMe()
  }
}
</script>
<style lang="sass" scoped>
.btn.pull-right
  margin-left: 10px
</style>



// WEBPACK FOOTER //
// src/components/user/UserLogin.vue